// Sector / Sub-Sector taxonomy — from the user's reference CSV (Sector, Business/Subsector).
// Product Segment has no fixed list (matches the Projectzo UX: freely typed once Sub Sector
// is chosen), so only two levels are seeded here; the picker itself allows custom entries
// at every level via ComboInput (see dprFields.js).
export const SECTOR_SUBSECTORS = {
  Manufacturing: [
    'Pharmaceutical Drugs', 'Textiles and Apparel', 'Automobiles and Auto Parts', 'Electronic Goods',
    'Chemicals', 'Iron and Steel', 'Cement', 'Paper and Paper Products', 'Plastics and Rubber Products',
    'Machinery and Equipment', 'Electrical Equipment', 'Gems and Jewellery', 'Leather and Leather Products',
    'Ceramics and Glassware', 'Furniture and Fixtures', 'Petroleum Products', 'Cosmetics and Personal Care Products',
    'Footwear', 'Medical Equipment and Supplies', 'Household Appliances', 'Sporting Goods and Toys',
    'Stationery and Office Supplies', 'Construction Materials', 'Packaging Materials', 'Industrial Gases',
    'Paints and Varnishes', 'Fertilizers and Pesticides', 'Heavy Machinery and Equipment',
    'Water Treatment and Purification Systems', 'Telecommunications Equipment', 'Batteries and Storage Devices',
    'Renewable Energy Equipment', 'Musical Instruments', 'Defense Equipment', 'Automotive Batteries',
    'Safety Equipments', 'Solar Panels and Systems', 'Construction Machinery', 'Elevators and Escalators',
    'Textile Machinery', 'Shipbuilding', 'Industrial Fasteners', 'Industrial Valves and Actuators',
    'Industrial Boilers and Heat Exchangers', 'Leather', 'Aviation', 'Recycling', 'Engineering Goods',
    'Fashion Accessories', 'Handicrafts',
  ],
  Services: [
    'Counseling and Therapy Services', 'Banking and Finance', 'Event Management Services', 'Engineering Services',
  ],
  Trading: [
    'Dairy Products', 'Meat Products', 'Fish and Seafood', 'Tobacco Products', 'Alcoholic Beverages',
    'Beverages (non-alcoholic)', 'Cleaning Products', 'Personal Hygiene Products', 'Insecticides and Pesticides',
    'Animal Feed', 'Retail Displays and Fixtures', 'Office Furniture and Supplies', 'Diamonds and other Precious Stones',
    'Tea and Coffee', 'Spices and Herbs', 'Silk and other Textile Fibers', 'Jute and other Natural Fibers',
    'Rubber and Latex', 'Essential Oils and Fragrances', 'Incense and Aromatics', 'Organic and Natural Products',
    'Handicrafts and Artisanal Goods',
  ],
  'Food Processing': [
    'Gluten-free baked goods', 'Frozen pizza and pizza crusts', 'Fruit preserves and spreads',
    'Jerky and dried meat snacks',
  ],
};

export const SECTORS = Object.keys(SECTOR_SUBSECTORS);

// Common units of measure for Installed Input Capacity — every industry
// measures throughput differently (oil/dairy in Ltr or MT, flour/grain in Kg
// or MT, garments in Nos, cement/civil in Cum), so this is a suggestion list
// feeding a free-typeable ComboInput, not a locked catalog.
export const UOM_OPTIONS = [
  'MT', 'Kg', 'Ltr', 'KL', 'Cum / m³', 'Sqm / m²', 'Rmt / m', 'Nos / Ea',
  'Bag', 'Box / Ctn', 'Bnd', 'Roll', 'Set / Pr', 'Gal', 'Brl', 'Hrs',
];

export function subSectorsFor(sector) {
  return SECTOR_SUBSECTORS[sector] || [];
}

// Catalogs used to power the searchable-with-custom-entry pickers on the
// capital/expense steps — same idea as Projectzo's per-category component list.
export const COMPONENT_CATALOG = {
  land_building: ['Industrial Shed', 'Water Tank', 'Boundary Wall with Gate', 'Labour Quarters', 'Processing Unit', 'Land Levelling', 'Paver Block Flooring', 'Office Building', 'Warehouse'],
  plant_machinery: ['Main Production Line', 'Packaging Machine', 'Generator / DG Set', 'Material Handling Equipment', 'Testing & QC Equipment', 'Effluent Treatment Plant'],
  other_assets: ['Furniture and Fixtures', 'Computers', 'Printer', 'Air Conditioners', 'Fire Safety Equipments', 'CCTV System', 'Biometric Attendance', 'Miscellaneous Tools & Equipments'],
  man_power: ['Manager', 'Supervisor', 'Skilled Worker', 'Semi Skilled Worker', 'Unskilled Worker', 'Machine Operator', 'Office Staff', 'Accountant', 'Security Guard'],
  direct_expenses: ['Electricity Expense', 'Water Utility and Maintenance', 'Transportation of Goods', 'Fuel Expense', 'Repairs & Maintenance', 'Miscellaneous'],
  preoperative: ['Company Incorporation / Registration Fees', 'Government License Fees', 'CA / Legal / Consultancy Fees', 'Project Report Preparation Fee', 'Know-How / Technical Fees', 'Trial Run Expenses', 'Travelling During Setup', 'Interest on Unsecured Loan During Construction'],
  indirect_expenses: ['Administrative Salary', 'Director Remuneration', 'Professional Fees', 'Office Rent', 'Selling & Marketing Expense', 'Travelling Expenses', 'Insurance', 'Audit Fees', 'Postage, Telephone & Office Supplies'],
  sources_of_finance: ["Promoter's Capital", 'Reserves & Surplus', 'Unsecured Loan from Directors/Partners', 'Share Capital', "Partner's Capital Account", 'Friends & Family Loan'],
};
